import React, { useState, useRef } from "react";
import { Form, Input, Button, Space, Table, Menu, Image } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import VideoPlayer from '../../components/VideoPlayer';
const MediaReviewContent = (props) => {
  const { TextArea } = Input;
  const current = props.current;
  //表头
  const columns = [
    {
      title: "名人ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "名人昵称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "订单号",
      dataIndex: "orderId",
      key: "orderId",
    },
    {
      title: "Deadline",
      dataIndex: "deadline",
      key: "deadline",
    },
    {
      title: "提交时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "拍摄要求",
      dataIndex: "requirement",
      key: "requirement",
    },
    {
      title: "媒体",
      dataIndex: "media",
      key: "media",
      render: (media) => (
        <div>
          {media
            ? media.map((item) =>
                item.type === "img" ? (
                  <Image
                    key={item.url}
                    src={item.url}
                    width={150}
                    style={{ marginBottom: 10 }}
                  />
                ) : (
                  <VideoPlayer key={item.url}  url={item.url} width={150} />
                )
              )
            : "无"}
        </div>
      ),
    },
    {
      title: "备注",
      dataIndex: "remark",
      key: "remark",
      render: (_, record) => (
        <Form.Item name={record.key} initialValue={record.remark}>
          <TextArea rows={4} />
        </Form.Item>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            <Button type="primary" onClick={() => onClickSubmit(record)}>
              通过
            </Button>
            {current !== "denied" && (
              <Button onClick={() => onClickDenied(record)}>违规</Button>
            )}
          </Space>
        </div>
      ),
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //点击通过按钮
  const onClickSubmit = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "pass";
    formRef.current.submit();
  };
  //点击未符合按钮
  const onClickDenied = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "denied";
    formRef.current.submit();
  };
  //提交表单
  const handleSubmit = (value) => {
    //要提交的数据
    let status;
    if (formRef.current.btn === "denied") {
      status = "denied";
    } else {
      status = "pass";
    }
    const submitData = {
      key: formRef.current.key,
      remark: value[formRef.current.key],
      status: status,
    };
    //提交数据
    console.log(submitData);
    //取消数据展示
    setShowData(showData.filter((item) => item.key !== submitData.key));
  };
  //全部数据
  let data = [
    {
      key: "1",
      id: "123456",
      name: "马牛逼",
      orderId: "666666666666",
      deadline: "2023-7-21 21:00",
      submitTime: "2023-7-20 21:00",
      requirement: "马牛逼的拍摄要求",
      media: [
        {
          type: "img",
          url: "https://s2.loli.net/2023/07/25/fjouqVLAlTn2s58.png",
        },
      ],
      remark: "马牛逼的备注",
      status: "pending",
    },
    {
      key: "2",
      id: "10086",
      name: "迪迦",
      orderId: "9999999999999",
      deadline: "2023-7-21 21:00",
      submitTime: "2023-7-20 20:59",
      requirement: "迪迦的拍摄要求",
      media: [
        {
          type: "img",
          url: "https://s2.loli.net/2023/07/25/1daCqmZGQNUzoJ8.png",
        },
        {
          type: "video",
          url: "https://media.w3.org/2010/05/sintel/trailer.mp4",
        },
      ],
      remark: "迪迦的备注",
      status: "pending",
    },
  ];
  //展示的数据
  const [showData, setShowData] = useState(data);
  //搜索名人
  const search = (value) => {
    value.name || value.id || value.orderId
      ? setShowData(
          data.filter(
            (item) =>
              item.name === value.name ||
              item.id === value.id ||
              item.orderId === value.orderId
          )
        )
      : setShowData(data);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <p>
        {current === "pending" && `待处理${showData.length}条`}
        {current === "denied" && `未通过${showData.length}条`}
      </p>
      <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
        <Space style={{ marginBottom: 20 }}>
        <Form.Item label="订单号" name="orderId" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Form.Item label="名人ID" name="id" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Form.Item label="名人昵称" name="name" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <Form
        ref={formRef}
        name="remark"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
    </div>
  );
};

export default function MediaReview() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "pending";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "待处理",
      key: "pending",
    },
    {
      label: "未通过",
      key: "denied",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/mediaReview/pending" />} />
        <Route
          path="/pending"
          element={<MediaReviewContent current="pending" />}
        />
        <Route
          path="/denied"
          element={<MediaReviewContent current="denied" />}
        />
      </Routes>
    </div>
  );
}
